import React, { useCallback, useMemo } from 'react';
import { STEPS, types, useLocalChat } from '@guuru/chat-web';
import orderBy from 'lodash/orderBy';
import ChatRenderText from '../Text';
import Option from '../../Option';

interface ChatRenderCategoriesProps {
  message: React.ComponentProps<typeof ChatRenderText>['message'] & {
    metadata: {
      categories: {
        id: string;
        name: string;
        priority: number;
      }[];
    }
  };
  readOnly: boolean;
  locale?: string;
  // eslint-disable-next-line no-unused-vars
  dispatch?: (_: {
    type: string;
    processArgs: {
      category: string;
      categoryLabel: string;
    }
  }) => void;
}

const ChatRenderCategories = function ({
  message,
  locale = 'en',
  readOnly,
  dispatch = () => {},
}: ChatRenderCategoriesProps) {
  const { currentChatStep } = useLocalChat();
  const categories = message?.metadata?.categories;

  const handleSelection = useCallback((
    category: string,
    categoryLabel: string,
  ) => {
    dispatch({
      type: types.CHAT_RUN_NEXT_STEP,
      processArgs: {
        category,
        categoryLabel,
      },
    });
  }, [dispatch]);

  const sortedCategories = useMemo(() => (
    orderBy(categories, 'priority')
  ), [categories]);

  const showOptions = !readOnly
    && currentChatStep === STEPS.requestCategory
    && sortedCategories.length > 0;

  return (
    <ChatRenderText message={message} tooltip={false}>
      {showOptions && (
        <ul role="menu" aria-label="categories">
          {sortedCategories.map((category) => (
            <Option
              key={category.id}
              id={category.id}
              name={category.name}
              locale={locale}
              onClick={handleSelection}
            />
          ))}
        </ul>
      )}
    </ChatRenderText>
  );
};

export default ChatRenderCategories;
